export const VISITOR_COOKIE_NAME = "gbuuid";
export const VISITOR_COOKIE_EXPIRY_DAYS = 400;
export const VISITOR_COOKIE_MAX_AGE_SECONDS =
  VISITOR_COOKIE_EXPIRY_DAYS * 24 * 60 * 60;
